module.exports = __webpack_public_path__ + "image/header-icon3.png";